import { ProductType } from '@/types';

export const getIsBook = (productType: ProductType | null) =>
  productType === ProductType.Book;
